










import { Vue, Component } from 'vue-property-decorator';
import Conductores from '@/pantallas/CopilotoVirtual/Conductores/CopilotoConductores.vue';

@Component({
  components: { Conductores },
})
export default class ConductoresPantalla extends Vue {}
